import MergeIngredientModal from './MergeIngredientModal'

export default MergeIngredientModal
